import { useState } from 'react';
import { SecaoVendasDrillDownData, SecaoVendasData } from '../types/secaoVendasDrillDown';

export const useSecaoVendasDrillDown = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [drillDownData, setDrillDownData] = useState<SecaoVendasDrillDownData | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedSecao, setSelectedSecao] = useState<SecaoVendasData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [lastSpedFiscalId, setLastSpedFiscalId] = useState<number | null>(null);

  const openModal = async (secaoData: SecaoVendasData, spedFiscalId: number) => {
    setSelectedSecao(secaoData);
    setLastSpedFiscalId(spedFiscalId);
    setIsModalOpen(true);
    setLoading(true);
    setError(null);

    try {
      const nomeSecaoEncoded = encodeURIComponent(secaoData.nome);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}sped-fiscal/secao-vendas-drill-down/${spedFiscalId}/${nomeSecaoEncoded}`,
        {
          headers: {
            'Authorization': `Bearer ${document.cookie
              .split("; ")
              .find((row) => row.startsWith("authTokenMHP="))
              ?.split("=")[1]}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.erro || `HTTP error! status: ${response.status}`);
      }

      const data: SecaoVendasDrillDownData = await response.json();
      setDrillDownData(data);
    } catch (error) {
      console.error('Erro ao buscar detalhes da seção:', error);
      const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido ao carregar dados';
      setError(errorMessage);
      setDrillDownData(null);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedSecao(null);
    setDrillDownData(null);
    setError(null);
  };

  const retry = () => {
    if (selectedSecao && lastSpedFiscalId) {
      openModal(selectedSecao, lastSpedFiscalId);
    }
  };

  return {
    isModalOpen,
    drillDownData,
    loading,
    selectedSecao,
    error,
    openModal,
    closeModal,
    retry
  };
}; 